import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { Plus, Edit, Trash2 } from 'lucide-react';

export default function ProveedoresPage() {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        nombre: '', telefono: '', email: '', direccion: ''
    });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${API_URL}/api/providers`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                setProviders(await res.json());
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = editingId
            ? `${API_URL}/api/providers/${editingId}`
            : `${API_URL}/api/providers`;
        const method = editingId ? 'PUT' : 'POST';

        try {
            const res = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(formData)
            });
            if (res.ok) {
                setModalOpen(false);
                setFormData({ nombre: '', telefono: '', email: '', direccion: '' });
                setEditingId(null);
                fetchData();
            } else {
                alert('Error al guardar proveedor');
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Seguro que desea eliminar?')) return;
        try {
            await fetch(`${API_URL}/api/providers/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            fetchData();
        } catch (err) { console.error(err); }
    };

    const openEdit = (p) => {
        setFormData({
            nombre: p.nombre,
            telefono: p.telefono || '',
            email: p.email || '',
            direccion: p.direccion || ''
        });
        setEditingId(p.proveedor_id); // Use correct ID field based on DB schema
        setModalOpen(true);
    };

    return (
        <div className="p-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Gestión de Proveedores</h1>
                <button
                    onClick={() => { setEditingId(null); setFormData({ nombre: '', telefono: '', email: '', direccion: '' }); setModalOpen(true); }}
                    className="btn-primary flex items-center gap-2"
                >
                    <Plus size={18} /> Nuevo Proveedor
                </button>
            </div>

            {loading ? (
                <div>Cargando...</div>
            ) : (
                <div className="bg-white rounded-lg shadow overflow-hidden">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50 border-b">
                            <tr>
                                <th className="p-4 font-semibold text-gray-600">Nombre</th>
                                <th className="p-4 font-semibold text-gray-600">Teléfono</th>
                                <th className="p-4 font-semibold text-gray-600">Email</th>
                                <th className="p-4 font-semibold text-gray-600">Dirección</th>
                                <th className="p-4 font-semibold text-gray-600">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {providers.map(p => (
                                <tr key={p.proveedor_id} className="border-b hover:bg-gray-50">
                                    <td className="p-4 font-medium">{p.nombre}</td>
                                    <td className="p-4 text-gray-500">{p.telefono}</td>
                                    <td className="p-4 text-gray-500">{p.email}</td>
                                    <td className="p-4 text-gray-500">{p.direccion}</td>
                                    <td className="p-4 flex gap-2">
                                        <button onClick={() => openEdit(p)} className="text-blue-600 hover:text-blue-800 p-1">
                                            <Edit size={18} />
                                        </button>
                                        <button onClick={() => handleDelete(p.proveedor_id)} className="text-red-600 hover:text-red-800 p-1">
                                            <Trash2 size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {modalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                        <h2 className="modal-title">{editingId ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h2>
                        <form onSubmit={handleSubmit} className="form-grid">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input required value={formData.nombre} onChange={e => setFormData({ ...formData, nombre: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input value={formData.telefono} onChange={e => setFormData({ ...formData, telefono: e.target.value })} />
                            </div>
                            <div className="form-group full-width">
                                <label>Email</label>
                                <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                            </div>
                            <div className="form-group full-width">
                                <label>Dirección</label>
                                <input value={formData.direccion} onChange={e => setFormData({ ...formData, direccion: e.target.value })} />
                            </div>

                            <div className="form-actions">
                                <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded">Cancelar</button>
                                <button type="submit" className="btn-primary">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
